import * as React from 'react';
import { useSanityNewsByUrlId } from '../../../../../../../../../../../../../../sanity';
import { LeftMenuNewsMapper, LeftMenuNewsTitle } from './components';

export const LeftMenuNews = () => {
  const {
    data,
  } = useSanityNewsByUrlId();
  return data != null
    ? (
      <div>
        <LeftMenuNewsTitle />
        <LeftMenuNewsMapper />
      </div>
    )
    : null;
};
